import type { IUser } from '../users';

export interface IAppInstallationContext {
    user: IUser;
}
